import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { toast } from "sonner";

export default function DriverLogin() {
  const { user, ready, driverLogin } = useAuth();
  const nav = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    document.title = "IceFleet · Driver Login";
  }, []);

  if (ready && user?.role === "driver" && !user?.requires_password_change) {
    return <Navigate to="/driver" replace />;
  }
  if (ready && user?.role === "driver" && user?.requires_password_change) {
    return <Navigate to="/driver/set-password" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const result = await driverLogin(identifier, password);
    setBusy(false);
    if (!result.ok) {
      toast.error(result.error);
      return;
    }
    if (result.data?.requires_password_change) {
      toast.info("For security, you need to set a new password before continuing.");
      nav("/driver/set-password", { replace: true });
      return;
    }
    toast.success("Welcome.");
    nav("/driver", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-5">
      <form onSubmit={submit} data-testid="driver-login-form" className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-8 space-y-5">
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-sky-700">Driver</p>
          <h1 className="font-heading text-2xl font-semibold tracking-tight mt-1">Sign in</h1>
        </div>
        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-700">Email or phone</span>
          <input data-testid="driver-login-identifier" required value={identifier} onChange={(e) => setIdentifier(e.target.value)} className="mt-1.5 h-10 w-full rounded-md border border-slate-300 px-3 text-sm outline-none focus:border-slate-900 focus:ring-1 focus:ring-slate-900" />
        </label>
        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-700">Password</span>
          <input data-testid="driver-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-10 w-full rounded-md border border-slate-300 px-3 text-sm outline-none focus:border-slate-900 focus:ring-1 focus:ring-slate-900" />
        </label>
        <button type="submit" disabled={busy} data-testid="driver-login-submit" className="w-full rounded-md bg-slate-900 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}